export { Textarea, renderTextarea, useTextarea } from './components/Textarea/index';
export type { TextareaSlots, TextareaProps, TextareaState } from './components/Textarea/index';
